import { Truck } from 'lucide-react';
import { SimpleCrudPage } from './_SimpleCrudPage';
import { vehicles, type Vehicle } from '../hooks/useArbreapains';

export function VehiclesPage() {
  return (
    <SimpleCrudPage<Vehicle>
      title="Véhicules"
      itemLabel="véhicule"
      icon={<Truck size={18} />}
      query={vehicles.useList()}
      createMut={vehicles.useCreate() as never}
      updateMut={vehicles.useUpdate() as never}
      deleteMut={vehicles.useDelete()}
      fields={[
        { key: 'name', label: 'Nom', required: true, placeholder: 'Camion 1' },
        { key: 'license_plate', label: 'Immatriculation', placeholder: 'AB-123-CD' },
      ]}
      renderExtra={(v) =>
        v.license_plate ? (
          <p className="text-xs text-stone-500 mt-0.5 font-mono">{v.license_plate}</p>
        ) : null
      }
    />
  );
}
